import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';
import { fragments } from './quote-data.model';

export const getQuoteOptionByIdQuery: DocumentNode = gql`
  query quote($id: Int!) {
    quoteOption(id: $id) {
      id
      description
      uuid
      quoteData {
        ...QuoteDataFields
      }
    }
  }
  ${fragments.quoteData}
`;

export const getQuoteOptionByUuidQuery: DocumentNode = gql`
  query getQuoteOptionByUuidQuery($uuid: ID!) {
    getOneByUuidDistributor(uuid: $uuid) {
      id
      description
      uuid
      quoteData {
        ...QuoteDataFields
      }
    }
  }
  ${fragments.quoteData}
`;

export const createQuoteQuery: DocumentNode = gql`
  mutation createQuote(
    $quoteInput: QuoteInput
    $quoteDataInput: QuoteDataInput
  ) {
    createQuote(quoteInput: $quoteInput, quoteDataInput: $quoteDataInput) {
      quote {
        id
        description
      }
      quoteRevision {
        id
        description
      }
      quoteOption {
        id
        description
        uuid
        quoteData {
          ...QuoteDataFields
        }
      }
    }
  }
  ${fragments.quoteData}
`;

export const createQuoteRevisionQuery: DocumentNode = gql`
  mutation createQuoteRevision($revision: QuoteRevisionInput) {
    createQuoteRevision(quoteRevisionInput: $revision) {
      id
      description
    }
  }
`;

export const createQuoteOptionQuery: DocumentNode = gql`
  mutation createQuoteOption($option: QuoteOptionInput) {
    createQuoteOption(quoteOptionInput: $option) {
      id
      description
    }
  }
`;

export const updateQuoteOptionQuery: DocumentNode = gql`
  mutation updateQuoteOption($option: QuoteOptionInput) {
    updateQuoteOption(quoteOptionInput: $option) {
      id
      description
    }
  }
`;

export const getHeavyLoadTypeDefault: DocumentNode = gql`
  query getHeavyLoadTypeDefault {
    loadTypeDefault(description: "Heavy") {
      id
      liveLoad
      centres
      deckingSection {
        id
      }
    }
  }
`;
